<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Incident Listing</strong>
                        <div class="card-header-actions">
                              <button :disabled="isReadOnly"
                                class="btn btn-sm btn-primary mr-4 btn-pill"
                                v-on:click="useradd('add')"
                                type="button"
                              >
                                <i class="fa fa-plus"></i> Add Incident
                              </button>
                        </div>
                    </div>

                    <div>
                        <b-col sm="5">
                            <b-form-group label-cols-sm="3" label="Search : " class="mb-0">
                                <b-input-group>
                                  <b-form-input v-model="filter" placeholder="Search..."></b-form-input>
                                  <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </div>

                    <b-row>
                        <b-col>
                            <div class="text-right">
                               <h6><b>Total Records : <span style="color: red;">{{ Incident_list.length }}</span></b></h6>
                            </div>
                        </b-col>
                    </b-row>

                    <div>
                        <b-table responsive :fields="fields" :items="Incident_list" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                              </div>
                              <template slot="lastmodifieddate" slot-scope="row">
                                <div>
                                    {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                                </div>
                            </template>
                            <template slot="show_details" slot-scope="row">
                                <b-button :disabled="isReadOnly"
                                  size="sm"
                                  data-toggle="tooltip"
                                  title="View Open Incident"
                                  @click="editincident(row.item,'edit')"
                                  :modalShow= modalShow
                                ><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</b-button>
                            </template>
                            <template slot="status" slot-scope="row">
                                <span data-toggle="tooltip" title="InActive" v-if="row.item.status === '0'">
                                    <span class="badge badge-danger">Inative</span>
                                </span>
                                <span data-toggle="tooltip" title="Active" v-else>
                                    <span class="badge badge-success">Active</span>
                                </span>
                            </template>
                        </b-table>
                    </div>
                   
                   
                    <b-modal :title="modalStatus=='add'? 'Add Incident': 'Edit Incident'" v-model="modalShow" size="xl" hide-footer>
                        <template slot="default" slot-scope="{ hide }">
                            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                                <b-row>
                                    <b-col sm="6">
                                        <b-row>
                                            <b-col sm="3">
                                                <label>Incident Level</label>&nbsp;<span style="color: red;">*</span> :
                                            </b-col>
                                            <b-col sm="7">
                                                <b-form-group :disabled="modalStatus === 'edit'">
                                                    <b-form-select v-model="selecteditincident.incidentlevel" name="incidentlevel" @change="handleForm"
                                                    v-validate="'required'"
                                                     
                                                    :class="{
                                                    input: true,
                                                    'is-invalid': errors.has('form-1.incidentlevel'),
                                                    }">
                                                        <option :value="selected_type">--Select Type--</option>
                                                        <option value="hub">Hub Level</option>
                                                        <option value="vehicle">Vehicle Level</option>
                                                    </b-form-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('incidentlevel')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.incidentlevel')"
                                                        class="help text-danger"
                                                        >{{ errors.first('form-1.incidentlevel') }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row v-if="incidentfields === true">
                                            <b-col sm="3">
                                                <label>Incident Name</label>&nbsp;<span style="color: red;">*</span> :
                                            </b-col>
                                            <b-col sm="7">
                                                <b-form-group>
                                                    <b-form-input v-model="selecteditincident.incident_name" 
                                                    name="incident name"
                                                    v-validate="'required'"
                                                    :class="{
                                                    input: true,
                                                    'is-invalid': errors.has('form-1.incident name'),
                                                    }"
                                                    placeholder="Add Incident Name">
                                                    </b-form-input>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('incident name')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.incident name')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-1.incident name") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col sm="3">
                                                <label>Select Type</label>&nbsp;<span style="color: red;">*</span> : 
                                            </b-col>
                                            <b-col sm="7">
                                                <b-form-group>
                                                    <b-form-select v-model="selecteditincident.status" name="status"
                                                     v-validate="'required'"
                                                    :class="{
                                                    input: true,
                                                    'is-invalid': errors.has('form-1.status'),
                                                    }">
                                                        <option :value="selected_type">--Select Type--</option>
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </b-form-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('status')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.status')"
                                                        class="help text-danger"
                                                        >{{ errors.first('form-1.status') }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                            <b-col sm="3">
                                                <label>Incident Type</label>&nbsp;<span style="color: red;">*</span> :
                                            </b-col>
                                            <b-col sm="7">
                                                <b-form-group>
                                                    <b-form-select v-model="selecteditincident.incidenttype" name="incidenttype"
                                                     v-validate="'required'"
                                                    :class="{
                                                    input: true,
                                                    'is-invalid': errors.has('form-1.incidenttype'),
                                                    }">
                                                        <option :value="selected_type">Internal/External/Vehicle</option>
                                                        <option value="internal">Internal</option>
                                                        <option value="external">External</option>
                                                        <option value="vehicle">Vehicle</option>
                                                    </b-form-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('incidenttype')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.incidenttype')"
                                                        class="help text-danger"
                                                        >{{ errors.first('form-1.incidenttype') }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-row v-if="incidentfields === true">
                                            <b-col sm="3">
                                                <label>Comment : </label>
                                            </b-col>
                                            <b-col sm="9">
                                                <b-form-group>
                                                    <b-form-textarea id="textarea" v-model="selecteditincident.comment" placeholder="Enter comment" rows="8"></b-form-textarea>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <hr>
                                <br>
                                <div slot="footer" class="text-right">
                                    <div id="overlayModal">
                                        <div class="loaderModal"></div>
                                      </div>
                                    <b-button type="submit" size="md" class="mr-4" variant="primary"  v-if="modalStatus=='edit'">
                                    Save Incident </b-button
                                    >
                                    <b-button type="submit" size="md" class="mr-4" variant="primary"
                                    v-if="modalStatus=='add'">
                                        ADD Incident </b-button>
                                    <b-button size="md" variant="danger" @click="editcancel()"
                                    >cancel</b-button
                                    >
                                </div>
                            </b-form>
                        </template>
                        
                        <template slot="modal-footer" slot-scope="{ hide }">
                            <b-button size="sm" style="display:none">
                              Cancel
                            </b-button>
                        </template>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>        
    </div>
</template>

<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
export default {
    data() {
        return {
            filter: null,
            fields: [
                { key: "incident_id",  label: "Incident Code"},
                { key: "incident_name",  label: "Incident Name"},
                { key: "incidentlevel",  label: "Incident Level"},
                { key: "incidenttype",  label: "Incident Type"},
                { key: "comment",  label: "Comment"},
                { key: "lastmodifiedby",  label: "Last Modified By"},
                { key: "lastmodifieddate",  label: "Last Modified On"},
                {key: "status",  label: "Active"},
                { key: "show_details",  label: "Action"},
            ],
            Incident_list :[],
            totalRows :'',
            modalShow :false,
            isBusy :false,
            selecteditincident :{
                comment:'',
            },
            modalStatus:'',
            incidentfields: false,
            accessBody:[],
            isReadOnly:false,
        }
    },

    computed: {
      validation() {
        const regex = /[!@#$%^&*(),?"';:{}|<>]/g;
        if(this.selecteditincident.incident_name){
            return !this.selecteditincident.incident_name.match(regex)
        }
        else{
            return true;
        }
        
      }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();
        this.incidentList();
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Incident Master' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Incident Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        useradd: function(value) {
            this.selecteditincident={}
            this.modalStatus='';
            this.modalStatus=value;
            console.log("model",this.modalStatus)
            this.modalShow = ! this.modalShow;
            this.incidentfields=false;
        },

        incidentList : function () {
            this.isBusy = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            const obj = {
                status: 2
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/incidentList`,obj).then(result => {
                    this.isBusy = false;
                if (result.body.returnmsg === 'Successful') {  
                    this.Incident_list = result.body.returnvalue;
                    // console.log("Incident list",this.Incident_list)
                    this.totalRows = result.body.returnvalue.length;
                    // console.log( this.totalRows)
                } else {
                    this.Incident_list = result.body;
                    this.totalRows = result.body.length;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        validateForm(scope) {
            // alert("ok")
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    console.log(this.modalStatus);
                    if (this.modalStatus=='edit') {
                        this.saveincident();
                    } else {
                        this.addincident();
                    }
                }
            });
        },

        editincident :function (value,data) {
            console.log(data)
            this.modalStatus='';
            this.modalStatus=data;
            console.log("value",value)
            this.selecteditincident = value;
            this.modalShow = ! this.modalShow;
            this.incidentfields=true;
        },

        editcancel: function() {
            this.selecteditincident = [];
            this.modalStatus='';
            this.modaleditStatus='';
            this.modalShow = !this.modalShow;
            this.incidentfields = true;
        },
            
        saveincident : function () {
            document.getElementById("overlayModal").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            // console.log(userInfo)
            
            const obj =  {
                incident_id : this.selecteditincident.incident_id,
                incident_name : this.selecteditincident.incident_name,
                comment : this.selecteditincident.comment==null ? "" :this.selecteditincident.comment,
                status : this.selecteditincident.status,
                lastmodifiedby : `${userInfo.sysemailid}`,
                // incidentlevel: this.selecteditincident.incidentlevel,
                incidenttype: this.selecteditincident.incidenttype
            };
            console.log("obj",obj)
            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/editIncident`,obj).then(result => {
                document.getElementById("overlayModal").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: "Updated Successfully",
                        type: "success",
                        timer: 30000,
                    });

                    this.selecteditincident = [];
                    this.incidentList();
                    this.modalShow = ! this.modalShow;
                } else {
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 300000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        addincident : function () {
            document.getElementById("overlayModal").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const obj =  {
                incident_name : this.selecteditincident.incident_name,
                comment : this.selecteditincident.comment,
                status : this.selecteditincident.status,
                createdby : `${userInfo.sysemailid}`,
                lastmodifiedby : `${userInfo.sysemailid}`,
                incidentlevel: this.selecteditincident.incidentlevel,
                incidenttype: this.selecteditincident.incidenttype
            };
            console.log("obj",obj)
            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addIncident`,obj).then(result => {
                document.getElementById("overlayModal").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: "Updated Successfully",
                        type: "success",
                        timer: 30000,
                    });

                    this.selecteditincident = [];
                    this.incidentList();
                    this.modalShow = ! this.modalShow;
                } else {
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 300000,
                    });
                }
            })  
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        handleForm: function () {
            if (this.selecteditincident.incidentlevel === "hub" || this.selecteditincident.incidentlevel === "vehicle") {
                this.incidentfields= true
            }   
        }
    },
}
</script>

<style>

.modal-body {
    padding: 20px 30px 20px 30px;
}

</style>